import React, { Suspense } from "react";

import { Provider } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import BasicLoading from "ZeroRuby/BasicLoading";

import { ErrorHandler } from "Cobalt/ErrorHandler";
import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";
import { ThemeProvider } from "Theme/Context";

import Chrome from "./components/Chrome";
import EmployeeContributionsPage from "./pages/EmployeeContributions";
import EmployeeEligilityPage from "./pages/EmployeeEligibility";
import OverviewPage from "./pages/OverviewPage";
import PolicyDetailsPage from "./pages/PolicyDetails";
import StatusPage from "./pages/Status";
import { useGetBenAdminRenewalQuery, createStore } from "./redux";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

const useData = () => {
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();

  const { isLoading: isLoadingBenAdminRenewal, data: _benAdminRenewal } = useGetBenAdminRenewalQuery(null);

  const { path } = useRouteMatch();
  const nextPageUrl = `${path}/overview`;

  return {
    isLoading: isLoadingSiteConfig || isLoadingBenAdminRenewal,
    nextPageUrl,
  };
};

const Routes = () => {
  const { path } = useRouteMatch();
  const { isLoading, nextPageUrl } = useData();
  return isLoading ? (
    <LoadingPage />
  ) : (
    <Suspense fallback={<LoadingPage />}>
      <ErrorHandler name="BenAdminRenewal">
        <Switch>
          <Route path={`${path}`} exact>
            <Redirect to={nextPageUrl} />
          </Route>
          <Route path={`${path}/overview`} exact>
            {(props) => <OverviewPage {...props} />}
          </Route>
          <Route path={`${path}/policy-details`} exact>
            {(props) => <PolicyDetailsPage {...props} />}
          </Route>
          <Route path={`${path}/employee-eligibility`} exact>
            {(props) => <EmployeeEligilityPage {...props} />}
          </Route>
          <Route path={`${path}/employee-contributions`} exact>
            {(props) => <EmployeeContributionsPage {...props} />}
          </Route>
          <Route path={`${path}/status`} exact>
            {(props) => <StatusPage {...props} />}
          </Route>
        </Switch>
      </ErrorHandler>
    </Suspense>
  );
};

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <PartnerProvider>
        <ThemeProvider>
          <ScrollToTop>
            <Routes />
          </ScrollToTop>
        </ThemeProvider>
      </PartnerProvider>
    </Provider>
  );
};

export default App;
